import expandingVideo from '../blocks/expanding-video';
import headRoom from 'headroom.js';

export default {
  init() {
    expandingVideo.init();

    // grab an element
    let header = document.querySelector("header");
    // construct an instance of Headroom, passing the element
    let stickyHeader  = new headRoom(header, {
      offset : 120,
      treshold : 5,
      onPin : function() {
        $(header).addClass('has-pinned');
      },
      onTop : function() {
        $(header).removeClass('has-pinned');
      },
    });

    stickyHeader.init();

  },
}



// WEBPACK FOOTER //
// ./scripts/routes/case-studies.js